<template>
  <b-overlay :show="loading">
    <b-card-actions action-collapse title="Daftar Teritori">
      <b-row class="align-items-end mb-1">
        <b-col md="3" sm="6" class="my-1">
          <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="5" sm="6" class="my-1">
          <b-form-group label="Cari" label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Cari teritori..."
                @keyup.enter="applySearch"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="clearSearch">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12" class="my-1 d-flex justify-content-md-end">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            @click="add"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <b-modal
        id="modal-teritori"
        v-model="showModal"
        centered
        :title="id ? 'Form Ubah' : 'Form Tambah'"
        hide-footer
      >
        <b-form>
          <b-form-group label="Nama Teritori" label-for="nama_teritori">
            <b-form-input
              id="nama_teritori"
              v-model="form.nama_teritori"
              placeholder="Nama teritori"
            />
          </b-form-group>
          <b-form-group label="Keterangan (Opsional)" label-for="keterangan">
            <b-form-textarea
              id="keterangan"
              v-model="form.keterangan"
              placeholder="Keterangan"
              rows="3"
            />
          </b-form-group>
        </b-form>
        <div class="d-flex justify-content-end align-items-center mt-2">
          <b-button
            size="sm"
            class="mr-1"
            variant="outline-secondary"
            :disabled="saving"
            @click="showModal = false"
          >
            Batal
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="saving"
            @click="submit"
          >
            <b-spinner v-if="saving" small class="mr-50" />
            {{ saving ? "Menyimpan..." : id ? "Ubah" : "Simpan" }}
          </b-button>
        </div>
      </b-modal>

      <b-row>
        <b-col cols="12">
          <div
            v-if="!loading && !items.length"
            class="text-center text-muted py-4 border rounded"
          >
            Belum ada data teritori
            <span v-if="filter"> untuk pencarian “{{ filter }}”</span>.
          </div>
          <b-table
            v-else
            striped
            small
            hover
            responsive
            :items="items"
            :fields="fields"
            show-empty
            empty-text="Tidak ada data"
          >
            <template #cell(no)="row">
              <strong>
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </strong>
            </template>
            <template #cell(actions)="row">
              <b-button
                v-b-tooltip.hover.right="'Ubah'"
                size="sm"
                class="mr-1"
                variant="outline-info"
                @click="edit(row.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-b-tooltip.hover.right="'Hapus'"
                size="sm"
                variant="outline-danger"
                @click="remove(row.item)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col
          cols="12"
          class="d-flex justify-content-between align-items-center mt-1"
        >
          <small class="text-muted">Total {{ totalRows }} data</small>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card-actions>
  </b-overlay>
</template>

<script>
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BTable,
  BOverlay,
  VBTooltip,
  BModal,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea,
  BSpinner,
  BForm,
} from "bootstrap-vue";

export default {
  components: {
    BCardActions,
    ToastificationContent,
    BModal,
    BTable,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormTextarea,
    BSpinner,
    BForm,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showModal: false,
      id: null,
      activeAction: "tambah",
      form: {
        nama_teritori: "",
        keterangan: "",
      },
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      totalRows: 0,
      currentPage: 1,
      filter: "",
      fields: [
        { key: "no", label: "No" },
        { key: "nama_teritori", label: "Teritori" },
        { key: "keterangan", label: "Keterangan" },
        { key: "actions", label: "Aksi" },
      ],
      items: [],
      loading: false,
      saving: false,
    };
  },
  watch: {
    perPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();
    },
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    applySearch() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();
    },
    clearSearch() {
      this.filter = "";
      this.applySearch();
    },
    add() {
      this.id = null;
      this.activeAction = "tambah";
      this.resetForm();
      this.showModal = true;
    },
    remove(item) {
      this.$swal({
        title: "Anda yakin?",
        text: `Data teritori "${item.nama_teritori}" ini akan dihapus`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          item.fungsi = 1; // soft delete
          this.$store
            .dispatch("teritori/save", [item])
            .then(() => {
              this.getData();
              this.pesanBerhasilHapus();
            })
            .catch((e) => {
              this.pesanGagalHapus();
              this.displayError(e);
              return false;
            });
        }
      });
    },
    resetForm() {
      this.id = null;
      this.activeAction = "tambah";
      this.form = {
        nama_teritori: "",
        keterangan: "",
      };
    },
    buildPayload() {
      const payload = {
        nama_teritori: this.form.nama_teritori,
        keterangan: this.form.keterangan,
      };
      if (this.id) {
        payload.id = this.id;
      }
      return payload;
    },
    submit() {
      if (this.saving) return false;
      if (this.form.nama_teritori == null || this.form.nama_teritori === "") {
        this.pesanGagalSimpan();
        return false;
      }
      const payload = this.buildPayload();
      this.saving = true;
      this.$store
        .dispatch("teritori/save", [payload])
        .then(() => {
          this.getData();
          this.pesanBerhasilSimpan();
          this.resetForm();
          this.showModal = false;
        })
        .catch((e) => {
          console.error(e);
          this.displayError(e);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    edit(item) {
      this.id = item.id;
      this.activeAction = "ubah";
      this.form = {
        nama_teritori: item.nama_teritori || "",
        keterangan: item.keterangan || "",
      };
      this.showModal = true;
    },
    pesanBerhasilSimpan() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Berhasil menyimpan data",
            variant: "success",
          },
        },
        { position: "bottom-right" }
      );
    },
    pesanGagalSimpan() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Gagal menyimpan data, harap cek kembali data yang diisi",
            variant: "warning",
          },
        },
        { position: "bottom-right" }
      );
    },
    pesanBerhasilHapus() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Berhasil menghapus data",
            variant: "success",
          },
        },
        { position: "bottom-right" }
      );
    },
    pesanGagalHapus() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Gagal menghapus data, harap cek kembali data yang diisi",
            variant: "warning",
          },
        },
        { position: "bottom-right" }
      );
    },
    getData() {
      const params = {
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      };
      if (this.filter && String(this.filter).trim() !== "") {
        params.search = String(this.filter).trim();
      }

      this.loading = true;
      return this.$store
        .dispatch("teritori/getData", params)
        .then((result) => {
          this.items = Array.isArray(result) ? result : [];
          this.totalRows =
            typeof result.total !== "undefined"
              ? Number(result.total)
              : this.items.length;
        })
        .catch((e) => {
          console.error(e);
          this.displayError(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
